export const BLACK = '#222A30';
export const DARK_GRAY = '#303B44';
export const GRAY = '#606989';
export const PURPLE_GRAY = '#A1AADC';
export const GREEN = '#D5EE44';
export const OFF_WHITE = '#F9F9F9';
export const FOCUS_BLUE = '#7B61FF';
export const WHITE = '#FFFFFF';
export const SEAFOAM_GREEN = '#B5CDC5';
